import { getCurrentInstance } from '@/util';
import Tokens from '@/di/tokens';

export default function useDI() {
  const instance = getCurrentInstance();
  const container = instance.proxy.$di;
  return {
    container,
    Tokens,
  };
}
